var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('h1', {
    staticClass: "float-left display-3 mr-4"
  }, [_vm._v("404")]), _vm._v(" "), _c('h4', {
    staticClass: "pt-3"
  }, [_vm._v("Oops! You're lost.")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("The page you are looking for was not found.")])]), _vm._v(" "), _c('div', {
    staticClass: "input-prepend input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "prependedInput",
      "size": "16",
      "type": "text",
      "placeholder": "What are you looking for?"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Search")])])])])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d2b6e9d","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/Page404.vue
// module id = 817
// module chunks = 1